import React, { useState, useEffect } from "react";
import { Box, Card, useMediaQuery } from "@mui/material";
import './slider.css'; 
import { createTheme } from '@mui/material/styles';

const Slider = ({ image1, image2, image3 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
      },
    },
  });

  const isXsScreen = useMediaQuery(theme.breakpoints.down('xs'));

  const cards = [
    { id: 1, imageUrl: image1 },
    { id: 2, imageUrl: image2 },
    { id: 3, imageUrl: image3 },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === cards.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000); // Change slide every 3 seconds

    return () => clearInterval(interval);
  }, [cards.length]);

  if (isXsScreen) return null; // Hide slider on extra-small screens

  return (
    <Box className="slider-container">
      <Box
        className="slider-wrapper"
        sx={{
          width: `${cards.length * 100}%`,
          transform: `translateX(-${currentIndex * (100 / cards.length)}%)`,
        }}
      >
        {cards.map((card) => (
          <Card
            key={card.id}
            className="card"
            sx={{
              width: `${100 / cards.length}%`,
              backgroundImage: `url(${card.imageUrl})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              borderRadius: 0,
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default Slider;
